"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonFormSelect = void 0;
const React = require("react");
const form_utils_1 = require("../../../utils/form.utils");
const BronsonFormSelect = (props) => {
    const [hasError, setError] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState([]);
    const inputRef = React.useRef(null);
    React.useEffect(() => {
        if (inputRef && inputRef.current)
            inputRef.current.value = props.defaultValue;
    }, [props.defaultValue]);
    const selectId = (0, form_utils_1.generateElementId)(props.elementId);
    return (React.createElement(React.Fragment, null,
        props.label &&
            (0, form_utils_1.renderLabel)(props.label, props.validations, props.tooltip, selectId),
        React.createElement("div", { style: { display: 'flex' } },
            React.createElement("div", { className: `c-input  c-input--select ${props.wrapperClassModifier
                    ? props.wrapperClassModifier
                    : ''}`, style: { flex: '1' } },
                React.createElement("select", { className: `c-input__input ${props.elementClassModifier
                        ? props.elementClassModifier
                        : ''} ${props.hasError || hasError ? 'is-error' : ''}`, id: selectId, defaultValue: props.defaultValue || undefined, disabled: props.isDisabled, ref: inputRef, onChange: (event) => {
                        (0, form_utils_1.handleChange)(event, errorMessage, setErrorMessage, setError, props.onChange, props.validations);
                    } }, props.children))),
        (0, form_utils_1.renderError)(hasError, errorMessage, props.hasError, props.errorMessage)));
};
exports.BronsonFormSelect = BronsonFormSelect;
